import type { DividendCalendarEntry } from "@/components/portfolio/dividend-calendar-card";

/** RFC 5545: Zeilen über 75 Oktette werden mit "\r\n " (führendes Leerzeichen = Fortsetzung)
 * umgebrochen - ohne Faltung verwerfen manche Kalender-Importe (u.a. ältere Outlook-Versionen)
 * die betroffene Zeile stillschweigend statt sie nur zu kürzen. */
function foldLine(line: string): string {
  if (line.length <= 75) return line;
  let folded = "";
  let rest = line;
  while (rest.length > 75) {
    folded += rest.slice(0, 75) + "\r\n ";
    rest = rest.slice(75);
  }
  return folded + rest;
}

function escapeIcsText(text: string): string {
  return text.replace(/\\/g, "\\\\").replace(/;/g, "\\;").replace(/,/g, "\\,").replace(/\n/g, "\\n");
}

function toIcsDate(isoDate: string): string {
  return isoDate.replaceAll("-", "").slice(0, 8);
}

/**
 * Baut eine RFC-5545-.ics-Datei aus dem bereits geladenen Dividendenkalender (backlog.md ->
 * "Dividendenkalender als .ics-Datei exportierbar", Nutzwert-Katalog) - ein ganztägiges VEVENT
 * je Eintrag, importierbar in Google/Apple/Outlook-Kalender. Reine Funktion, kein I/O.
 */
export function buildDividendCalendarIcs(entries: DividendCalendarEntry[]): string {
  const stamp = `${new Date().toISOString().replace(/[-:]/g, "").split(".")[0]}Z`;
  const lines = [
    "BEGIN:VCALENDAR",
    "VERSION:2.0",
    "PRODID:-//Erikonomie//Dividendenkalender//DE",
    "CALSCALE:GREGORIAN",
  ];

  entries.forEach((entry, i) => {
    const amountLabel =
      entry.amountEurNet !== undefined
        ? `${entry.amountEurNet.toFixed(2)} EUR netto (ca.)`
        : `${entry.amount.toFixed(2)} ${entry.currency} brutto`;
    const statusLabel = entry.confirmed ? "" : " - voraussichtlich, noch nicht von Yahoo bestätigt";
    lines.push(
      "BEGIN:VEVENT",
      foldLine(`UID:erikonomie-div-${toIcsDate(entry.date)}-${entry.symbol}-${i}@erikonomie.de`),
      `DTSTAMP:${stamp}`,
      `DTSTART;VALUE=DATE:${toIcsDate(entry.date)}`,
      foldLine(`SUMMARY:${escapeIcsText(`${entry.name} Dividende`)}`),
      foldLine(`DESCRIPTION:${escapeIcsText(`${amountLabel}${statusLabel}`)}`),
      "END:VEVENT",
    );
  });

  lines.push("END:VCALENDAR");
  return lines.join("\r\n");
}
